<template>
    <section class="sub-container">
        <h2 class="sub-title-h2">
            {{$lang('subscriptionStatistics.title')}}
        </h2>
        <div class="sub-stat-items">
            <a class="sub-stat-item" href="/cabinet/pages">
                <h3 class="sub-stat-item__title">{{ $lang('subscriptionStatistics.total_pages') }}</h3>
                <div class="sub-stat-info">
                    <span class="sub-stat-count">{{ statistic.total_pages }}</span>
                    <svg class="sub-stat-icon" width="10" height="10">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-link_arrow"></use>
                    </svg>
                </div>
            </a>

            <a class="sub-stat-item" href="/cabinet/pages">
                <h3 class="sub-stat-item__title">{{ $lang('subscriptionStatistics.extended_pages') }}</h3>
                <div class="sub-stat-info">
                    <span class="sub-stat-count">{{ statistic.extended_pages }}</span>
                    <svg class="sub-stat-icon" width="10" height="10">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-link_arrow"></use>
                    </svg>
                </div>
            </a>

            <a class="sub-stat-item" href="/cabinet/pages">
                <h3 class="sub-stat-item__title">{{ $lang('subscriptionStatistics.permanent_extended_pages') }}</h3>
                <div class="sub-stat-info">
                    <span class="sub-stat-count">{{ statistic.permanent_extended_pages }}</span>
                    <svg class="sub-stat-icon" width="10" height="10">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-link_arrow"></use>
                    </svg>
                </div>
            </a>

            <a 
                class="sub-stat-item"
                :class="{'sub-stat-item--inactive' : !subscriptionActive}"
                :href="subscriptionActive ? '/cabinet/pages' : '#'"
            >
                <h3 class="sub-stat-item__title">{{ $lang('subscriptionStatistics.subscription_extended_pages') }}</h3>
                <div class="sub-stat-info">
                    <span 
                        class="sub-stat-count"
                        :class="{'sub-stat-count--inactive' : !subscriptionActive}"
                    >
                        {{ statistic.subscription_extended_pages }}
                    </span>

                    <svg v-if="subscriptionActive" class="sub-stat-icon" width="10" height="10">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-link_arrow"></use>
                    </svg>
                    <el-popover
                        v-else
                        placement="bottom"
                        width="230"
                        trigger="hover"
                        :content="$lang('subscriptionStatistics.popover')"
                        popper-class="sub-stat-info__window"
                    >
                        <img slot="reference" class=sub-stat-popover-tip src="/assets/front/img/popover_tip.svg" alt="#">
                    </el-popover>
                </div>
            </a>

            <a class="sub-stat-item" href="/cabinet/pages">
                <h3 class="sub-stat-item__title">{{ $lang('subscriptionStatistics.short_pages') }}</h3>
                <div class="sub-stat-info">
                    <span class="sub-stat-count">{{ statistic.short_pages }}</span>
                    <svg class="sub-stat-icon" width="10" height="10">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-link_arrow"></use>
                    </svg>
                </div>
            </a>

            <a class="sub-stat-item" href="/cabinet/tree">
                <h3 class="sub-stat-item__title">{{ $lang('subscriptionStatistics.tree_persons')}} </h3>
                <div class="sub-stat-info">
                    <span class="sub-stat-count">{{ statistic.tree_persons }}</span>
                    <svg class="sub-stat-icon" width="10" height="10">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-link_arrow"></use>
                    </svg>
                </div>
            </a>
        </div>
    </section>
</template>

<script>
import ApiService from '../../api/api';

export default {
    name: 'SubscriptionStatistics',
    data() {
        return {
            subscription: window.laravel.latestSubscription,
            statistic: {},
        }
    },
    props: {
        subscriptionActive: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        fetchSubscriptionStats() {
            ApiService.get('/subscription/pages-stats')
                .then((response) => {
                    this.statistic = response.data;
                }).catch((error) => {
                    console.log(error);
            });
        }
    },
    mounted() {
        this.fetchSubscriptionStats();
    }
}
</script>